import Mock from 'mockjs'

const images = [
  'https://picsum.photos/300/400',
  'https://picsum.photos/300/500',
  'https://picsum.photos/300/600',
  'https://picsum.photos/300/450',
  'https://picsum.photos/300/550'
]

const videos = [
  'https://www.w3schools.com/html/mov_bbb.mp4',
  'http://vjs.zencdn.net/v/oceans.mp4'
]

// 生成图片feed数据
Mock.mock(/\/api\/feed\/images/, 'get', (options) => {
  const query = new URLSearchParams(options.url.split('?')[1])
  const page = parseInt(query.get('page')) || 1
  const pageSize = parseInt(query.get('pageSize')) || 10

  return {
    code: 200,
    data: {
      list: new Array(pageSize).fill(null).map(() => ({
        id: Mock.Random.guid(),
        title: Mock.Random.ctitle(5, 20),
        desc: Mock.Random.cparagraph(1, 3),
        imageUrl: images[Math.floor(Math.random() * images.length)],
        author: Mock.Random.cname(),
        likes: Mock.Random.natural(0, 1000),
        comments: Mock.Random.natural(0, 100),
        type: 'image'
      })),
      total: 100,
      page,
      pageSize
    }
  }
})

// 生成视频feed数据
Mock.mock(/\/api\/feed\/videos/, 'get', (options) => {
  const query = new URLSearchParams(options.url.split('?')[1])
  const page = parseInt(query.get('page')) || 1
  const pageSize = parseInt(query.get('pageSize')) || 10

  return {
    code: 200,
    data: {
      list: new Array(pageSize).fill(null).map(() => ({
        id: Mock.Random.guid(),
        title: Mock.Random.ctitle(5, 20),
        desc: Mock.Random.cparagraph(1, 3),
        videoUrl: videos[Math.floor(Math.random() * videos.length)],
        coverUrl: images[Math.floor(Math.random() * images.length)],
        author: Mock.Random.cname(),
        likes: Mock.Random.natural(0, 1000),
        comments: Mock.Random.natural(0, 100),
        type: 'video'
      })),
      total: 100,
      page,
      pageSize
    }
  }
}) 